import { EurekaZoneInfo } from './eureka';
import zadnorMap from './zadnor.png';

// https://xivapi.com/search?indexes=Fate&filters=ID%3E=1717,ID%3C=1742&columns=Description,Name,Url

export const zoneInfoZadnor: EurekaZoneInfo = {
  mapImage: zadnorMap,
  mapWidth: 1600,
  mapHeight: 1400,
  shortName: 'zadnor',
  hasTracker: false,
  onlyShowInactiveWithExplicitRespawns: true,
  treatNMsAsSkirmishes: true,
  mapToPixelXScalar: 39.067,
  mapToPixelXConstant: 10.03,
  mapToPixelYScalar: 39.247,
  mapToPixelYConstant: -202.55,
  fieldNotes: [
    {
      id: 31,
      name: {
        en: 'Atori Moribe',
        de: 'Atori Moribe',
        fr: 'Atori Moribe',
        ja: 'モリベのアトリ',
        cn: '守部花鸟',
        ko: '아토리 모리베',
        tc: '守部花鳥',
      },
      shortName: {
        en: 'Atori',
        de: 'Atori',
        fr: 'Atori',
        ja: 'アトリ',
        cn: '花鸟',
        ko: '아토리',
        tc: '花鳥',
      },
      rarity: 1,
    },
    {
      id: 32,
      name: {
        en: 'Kosyu',
        de: 'Kosyu',
        fr: 'Kosyu',
        ja: '虎髭',
        cn: '虎须',
        ko: '호랑수염',
        tc: '虎鬚',
      },
      shortName: {
        en: 'Kosyu',
        de: 'Kosyu',
        fr: 'Kosyu',
        ja: '虎髭',
        cn: '虎须',
        ko: '호랑수염',
        tc: '虎鬚',
      },
      rarity: 2,
    },
    {
      id: 33,
      name: {
        en: 'Oboro Torioi',
        de: 'Oboro Torioi',
        fr: 'Oboro Torioi',
        ja: 'オボロ・トリオイ',
        cn: '鸟追胧',
        ko: '토리오이 오보로',
        tc: '鳥追朧',
      },
      shortName: {
        en: 'Oboro',
        de: 'Oboro',
        fr: 'Oboro',
        ja: 'オボロ',
        cn: '鸟追胧',
        ko: '오보로',
        tc: '鳥追朧',
      },
      rarity: 1,
    },
    {
      id: 34,
      name: {
        en: 'Tsubame Oshidari',
        de: 'Tsubame Oshidari',
        fr: 'Tsubame Oshidari',
        ja: 'ツバメ・オシダリ',
        cn: '忍足燕',
        ko: '츠바메 오시다리',
        tc: '忍足燕',
      },
      shortName: {
        en: 'Tsubame',
        de: 'Tsubame',
        fr: 'Tsubame',
        ja: 'ツバメ',
        cn: '忍足燕',
        ko: '츠바메',
        tc: '忍足燕',
      },
      rarity: 3,
    },
    {
      id: 35,
      name: {
        en: 'Meryall Miller',
        de: 'Meryall Miller',
        fr: 'Meryall Miller',
        ja: 'メリオール・ミラー',
        cn: '梅丽奥尔·米勒',
        ko: '메리올 밀러',
        tc: '梅麗奧爾·米勒',
      },
      shortName: {
        en: 'Meryall',
        de: 'Meryall',
        fr: 'Meryall',
        ja: 'メリオール',
        cn: '梅丽奥尔',
        ko: '메리올',
        tc: '梅麗奧爾',
      },
      rarity: 2,
    },
    {
      id: 36,
      name: {
        en: 'Lovro aan Slanasch',
        de: 'Lovro aan Slanasch',
        fr: 'Lovro aan Slanasch',
        ja: 'ロヴロ・アン・スラナシュ',
        cn: '洛夫罗·安·斯拉娜失',
        ko: '로브로 안 슬라나쉬',
        tc: '洛夫羅·安·斯拉娜失',
      },
      shortName: {
        en: 'Lovro',
        de: 'Lovro',
        fr: 'Lovro',
        ja: 'ロヴロ',
        cn: '洛夫罗',
        ko: '로브로',
        tc: '洛夫羅',
      },
      rarity: 3,
    },
    {
      id: 37,
      name: {
        en: 'Llofii pyr Potitus',
        de: 'Llofii pyr Potitus',
        fr: 'Llofii pyr Potitus',
        ja: 'ロフィー・ピル・ポティトゥス',
        cn: '罗菲·皮尔·珀提图斯',
        ko: '로피 피르 포티투스',
        tc: '羅菲·皮爾·珀提圖斯',
      },
      shortName: {
        en: 'Llofii',
        de: 'Llofii',
        fr: 'Llofii',
        ja: 'ロフィー',
        cn: '罗菲',
        ko: '로피',
        tc: '羅菲',
      },
      rarity: 4,
    },
    {
      id: 38,
      name: {
        en: 'Fabineau quo Soranus',
        de: 'Fabineau quo Soranus',
        fr: 'Fabineau quo Soranus',
        ja: 'ファビノー・クォ・ソラノス',
        cn: '法比诺·库奥·索拉努斯',
        ko: '파비노 쿠오 소라누스',
        tc: '法比諾·庫奧·索拉努斯',
      },
      shortName: {
        en: 'Fabineau',
        de: 'Fabineau',
        fr: 'Fabineau',
        ja: 'ファビノー',
        cn: '法比诺',
        ko: '파비노',
        tc: '法比諾',
      },
      rarity: 2,
    },
    {
      id: 39,
      name: {
        en: 'Yamatsumi pyr Urabe',
        de: 'Yamatsumi pyr Urabe',
        fr: 'Yamatsumi pyr Urabe',
        ja: 'ヤマツミ・ピル・ウラベ',
        cn: '山祇·皮尔·卜部',
        ko: '야마츠미 피르 우라베',
        tc: '山祇·皮爾·卜部',
      },
      shortName: {
        en: 'Yamatsumi',
        de: 'Yamatsumi',
        fr: 'Yamatsumi',
        ja: 'ヤマツミ',
        cn: '山祇',
        ko: '야마츠미',
        tc: '山祇',
      },
      rarity: 3,
    },
    {
      id: 40,
      name: {
        en: 'Pagaga quo Vochstein',
        de: 'Pagaga quo Vochstein',
        fr: 'Pagaga quo Vochstein',
        ja: 'パガガ・クォ・バックスタイン',
        cn: '帕佳佳·库奥·弗克施泰因',
        ko: '파가가 쿠오 보크스타인',
        tc: '帕佳佳·庫奧·弗克施泰因',
      },
      shortName: {
        en: 'Pagaga',
        de: 'Pagaga',
        fr: 'Pagaga',
        ja: 'パガガ',
        cn: '帕佳佳',
        ko: '파가가',
        tc: '帕佳佳',
      },
      rarity: 1,
    },
    {
      id: 41,
      name: {
        en: 'Daguza oen Sus',
        de: 'Daguza oen Sus',
        fr: 'Daguza oen Sus',
        ja: 'ダクザ・エン・スース',
        cn: '达古扎·恩·苏斯',
        ko: '다그자 왼 수스',
        tc: '達古扎·恩·蘇斯',
      },
      shortName: {
        en: 'Daguza',
        de: 'Daguza',
        fr: 'Daguza',
        ja: 'ダクザ',
        cn: '达古扎',
        ko: '다그자',
        tc: '達古扎',
      },
      rarity: 1,
    },
    {
      id: 42,
      name: {
        en: 'Gilbrisbert quo Buteo',
        de: 'Gilbrisbert quo Buteo',
        fr: 'Gilbrisbert quo Buteo',
        ja: 'ジルブリスベル・クォ・ブテオ',
        cn: '吉尔布里斯贝尔·库奥·布特奥',
        ko: '질브리스베르 쿠오 부테오',
        tc: '吉爾布里斯貝爾·庫奧·布特奧',
      },
      shortName: {
        en: 'Gilbrisbert',
        de: 'Gilbrisbert',
        fr: 'Gilbrisbert',
        ja: 'ジルブリスベル',
        cn: '吉尔布里斯贝尔',
        ko: '질브리스베르',
        tc: '吉爾布里斯貝爾',
      },
      rarity: 2,
    },
    {
      id: 43,
      name: {
        en: 'Dabog aan Inivisch',
        de: 'Dabog aan Inivisch',
        fr: 'Dabog aan Inivisch',
        ja: 'ダボグ・アン・イニヴァシュ',
        cn: '达波格·安·因尼维失',
        ko: '다보그 안 이비니쉬',
        tc: '達波格·安·因尼維失',
      },
      shortName: {
        en: 'Dabog',
        de: 'Dabog',
        fr: 'Dabog',
        ja: 'ダボグ',
        cn: '达波格',
        ko: '다보그',
        tc: '達波格',
      },
      rarity: 5,
    },
    {
      id: 44,
      name: {
        en: 'Lyon quo Helsos',
        de: 'Lyon quo Helsos',
        fr: 'Lyon quo Helsos',
        ja: 'ライアン・クォ・ヘルソス',
        cn: '莱昂·库奥·赫尔索斯',
        ko: '라이언 쿠오 헬소스',
        tc: '萊昂·庫奧·赫爾索斯',
      },
      shortName: {
        en: 'Lyon',
        de: 'Lyon',
        fr: 'Lyon',
        ja: 'ライアン',
        cn: '莱昂',
        ko: '라이언',
        tc: '萊昂',
      },
      rarity: 5,
    },
    {
      id: 45,
      name: {
        en: 'Menenius sas Lanatus',
        de: 'Menenius sas Lanatus',
        fr: 'Menenius sas Lanatus',
        ja: 'メネニウス・サス・ラナトゥス',
        cn: '梅内纽斯·萨斯·拉那图斯',
        ko: '메네니우스 사스 라나투스',
        tc: '梅內紐斯·薩斯·拉那圖斯',
      },
      shortName: {
        en: 'Menenius',
        de: 'Menenius',
        fr: 'Menenius',
        ja: 'メネニウス',
        cn: '梅内纽斯',
        ko: '메네니우스',
        tc: '梅內紐斯',
      },
      rarity: 5,
    },
    {
      id: 46,
      name: {
        en: 'The Diablo Armament',
        de: 'Diablo-Armament',
        fr: 'Batterie d\'artillerie Diablo',
        ja: 'ディアブロ・アーマメント',
        cn: '迪亚布罗魔兵',
        ko: '디아블로 아머먼트',
        tc: '迪亞布羅魔兵',
      },
      shortName: {
        en: 'Diablo',
        de: 'Diablo',
        fr: 'Diablo',
        ja: 'ディアブロ',
        cn: '迪亚布罗',
        ko: '디아블로',
        tc: '迪亞布羅',
      },
      rarity: 3,
    },
  ],
  nms: {
    ofbeastsandbraggadocio: {
      label: {
        en: 'Of Beasts and Braggadocio',
        de: 'Die allergrößte Bestienbändigerin aller Zeiten',
        fr: 'Un jour, je serai la meilleure dresseuse',
        ja: '我執の魔獣使い',
        cn: '我见我执驯兽师',
        ko: '아집의 마수조련사',
        tc: '我見我執馴獸師',
      },
      fieldNotes: 31,
      shortLabel: {
        en: 'Beasts',
        de: 'Bestienbändigerin',
        fr: 'Dresseuse',
        ja: '我執の魔獣使い',
        cn: '我见我执驯兽师',
        ko: '아집의 마수조련사',
        tc: '我見我執馴獸師',
      },
      x: 24.1,
      y: 37.4,
      fateId: 1717,
    },
    partsandparcel: {
      label: {
        en: 'Parts and Parcel',
        de: 'Oboro auf der Jagd',
        fr: 'Les astres du jour et de la nuit',
        ja: '忍者オボロの出陣',
        cn: '忍者胧出阵',
        ko: '닌자 오보로 출진',
        tc: '忍者朧出陣',
      },
      fieldNotes: 33,
      shortLabel: {
        en: 'Parcel',
        de: 'Oboro',
        fr: 'Astres',
        ja: '忍者オボロの出陣',
        cn: '忍者胧出阵',
        ko: '닌자 오보로',
        tc: '忍者朧出陣',
      },
      x: 22.8,
      y: 34.2,
      fateId: 1718,
    },
    animmoraldilemma: {
      label: {
        en: 'An Immoral Dilemma',
        de: 'Ketzer Fabineau gibt sich die Ehre',
        fr: 'Malheureuses retrouvailles',
        ja: '傍白の外道術士',
        cn: '无心无惭邪道术师',
        ko: '잔학한 마술사',
        tc: '無心無慚邪道術師',
      },
      isCEPrecursor: true,
      fieldNotes: 37,
      shortLabel: {
        en: 'Dilemma',
        de: 'Ketzer Fabineau',
        fr: 'Retrouvailles',
        ja: '傍白の外道術士',
        cn: '无心无惭邪道术师',
        ko: '잔학한 마술사',
        tc: '無心無慚邪道術師',
      },
      x: 22.7,
      y: 34.2,
      fateId: 1719,
    },
    deadlydivination: {
      label: {
        en: 'Deadly Divination',
        de: 'Mörderischer Onmyoji',
        fr: 'Prêtre pernicieux',
        ja: '歳殺の陰陽士',
        cn: '阴阳师岁煞',
        ko: '세살신 음양사',
        tc: '陰陽師歲煞',
      },
      shortLabel: {
        en: 'Divination',
        de: 'Mörderischer Onmyoji',
        fr: 'Prêtre',
        ja: '歳殺の陰陽士',
        cn: '阴阳师岁煞',
        ko: '세살신 음양사',
        tc: '陰陽師歲煞',
      },
      x: 24.8,
      y: 31.4,
      fateId: 1720,
    },
    awrenchinthereconnaissanceeffort: {
      label: {
        en: 'A Wrench in the Reconnaissance Effort',
        de: 'Beobachten verboten',
        fr: 'Ni vu ni connu',
        ja: '偵察魔導兵器の排除',
        cn: '消灭侦察魔导兵器',
        ko: '정찰 마도 병기 파괴',
        tc: '消滅偵察魔導兵器',
      },
      shortLabel: {
        en: 'Wrench',
        de: 'Beobachten verboten',
        fr: 'Ni vu ni connu',
        ja: '偵察魔導兵器の排除',
        cn: '消灭侦察魔导兵器',
        ko: '정찰 마도 병기',
        tc: '消滅偵察魔導兵器',
      },
      x: 29.4,
      y: 35.4,
      fateId: 1721,
    },
    anotherpilotepisode: {
      label: {
        en: 'Another Pilot episode',
        de: 'Rückkehr des Magitek-Soldaten',
        fr: 'Dabog, soldat augmenté',
        ja: '再来の強化兵',
        cn: '强化兵再度袭来',
        ko: '다시 나타난 강화병',
        tc: '強化兵再度襲來',
      },
      isCEPrecursor: true,
      shortLabel: {
        en: 'Pilot',
        de: 'Magitek-Soldaten',
        fr: 'Dabog',
        ja: '再来の強化兵',
        cn: '强化兵再度袭来',
        ko: '강화병',
        tc: '強化兵再度襲來',
      },
      x: 28.0,
      y: 29.2,
      fateId: 1722,
    },
    breakingtheice: {
      label: {
        en: 'Breaking the Ice',
        de: 'Eiskalte Begegnung',
        fr: 'Qui s\'y frotte s\'y pique',
        ja: '術士大隊の迎撃',
        cn: '迎击术师大队',
        ko: '술사대대의 요격',
        tc: '迎擊術師大隊',
      },
      shortLabel: {
        en: 'Ice',
        de: 'Eiskalt',
        fr: 'Pique',
        ja: '術士大隊の迎撃',
        cn: '迎击术师大队',
        ko: '술사대대의 요격',
        tc: '迎擊術師大隊',
      },
      x: 24.8,
      y: 31.1,
      fateId: 1723,
    },
    meetthepuppetmaster: {
      label: {
        en: 'Meet the Puppetmaster',
        de: 'Lass die Puppen tanzen',
        fr: 'Celui qui tire les ficelles',
        ja: '人形使いとの邂逅',
        cn: '与人偶师的相遇',
        ko: '인형술사와 해후하다',
        tc: '與人偶師的相遇',
      },
      fieldNotes: 42,
      shortLabel: {
        en: 'Puppet',
        de: 'Puppen',
        fr: 'Ficelles',
        ja: '人形使いとの邂逅',
        cn: '与人偶师的相遇',
        ko: '인형술사와 해후',
        tc: '與人偶師的相遇',
      },
      x: 24.1,
      y: 37.4,
      fateId: 1724,
    },
    challengeaccepted: {
      label: {
        en: 'Challenge Accepted',
        de: 'Größtmöglicher anzunehmender Unfall',
        fr: 'Un problème de taille',
        ja: '立ちはだかる我執',
        cn: '战线壁垒我见我执',
        ko: '막아서는 아집',
        tc: '戰線壁壘我見我執',
      },
      fieldNotes: 40,
      shortLabel: {
        en: 'Challenge',
        de: 'Größtmöglicher',
        fr: 'Problème',
        ja: '立ちはだかる我執',
        cn: '战线壁垒我见我执',
        ko: '막아서는 아집',
        tc: '戰線壁壘我見我執',
      },
      x: 7.2,
      y: 28.8,
      fateId: 1725,
    },
    thubantheterrible: {
      label: {
        en: 'Th\'uban the Terrible',
        de: 'Bestien aus der Vorzeit',
        fr: 'Le dernier dinosaure',
        ja: '巨大古代獣との遭遇',
        cn: '遭遇古代巨兽',
        ko: '거대한 고대 짐승',
        tc: '遭遇古代巨獸',
      },
      shortLabel: {
        en: 'T\'huban',
        de: 'Bestien',
        fr: 'Dinosaure',
        ja: '巨大古代獣との遭遇',
        cn: '遭遇古代巨兽',
        ko: '고대 짐승',
        tc: '遭遇古代巨獸',
      },
      x: 8.6,
      y: 34.4,
      fateId: 1726,
    },
    anendtoatrocities: {
      label: {
        en: 'An End to Atrocities',
        de: 'Endkampf mit dem Ketzer',
        fr: 'L\'immaculée contre le malsain',
        ja: '外道術士との決着',
        cn: '与邪道术师一决胜负',
        ko: '잔학한 마술사와 결판내다',
        tc: '與邪道術師一決勝負',
      },
      isCEPrecursor: true,
      fieldNotes: 38,
      shortLabel: {
        en: 'Atrocities',
        de: 'Endkampf (Ketzer)',
        fr: 'Le malsain',
        ja: '外道術士との決着',
        cn: '与邪道术师一决胜负',
        ko: '마술사와 결판',
        tc: '與邪道術師一決勝負',
      },
      x: 4.9,
      y: 25.3,
      fateId: 1727,
    },
    ajustpursuit: {
      label: {
        en: 'A Just Pursuit',
        de: 'Gesucht: Der mörderische Meister',
        fr: 'Recherché dans deux pays',
        ja: '歳殺の手配犯',
        cn: '通缉犯岁煞',
        ko: '세살신 수배범',
        tc: '通緝犯歲煞',
      },
      fieldNotes: 34,
      shortLabel: {
        en: 'Pursuit',
        de: 'mörderische Meister',
        fr: 'Recherché',
        ja: '歳殺の手配犯',
        cn: '通缉犯岁煞',
        ko: '세살신 수배범',
        tc: '通緝犯歲煞',
      },
      x: 11.6,
      y: 27.6,
      fateId: 1728,
    },
    tankingup: {
      label: {
        en: 'Tanking Up',
        de: 'Energie für Seiryu Zwo',
        fr: 'Y\'a qu\'à se baisser',
        ja: '疑似青竜壁の生命線',
        cn: '仿制青龙壁的生命线',
        ko: '유사 청룡벽의 생명줄',
        tc: '仿製青龍壁的生命線',
      },
      isCEPrecursor: true,
      shortLabel: {
        en: 'Tanking',
        de: 'Seiryu Zwo',
        fr: 'Se baisser',
        ja: '疑似青竜壁の生命線',
        cn: '仿制青龙壁的生命线',
        ko: '유사 청룡벽',
        tc: '仿製青龍壁的生命線',
      },
      x: 8.1,
      y: 24.0,
      fateId: 1729,
    },
    supersolderrising: {
      label: {
        en: 'Supersoldier Rising',
        de: 'Der Magitek-Soldat schlägt zurück',
        fr: 'Guet-apens magitek',
        ja: '覚醒の強化兵',
        cn: '觉醒的强化兵',
        ko: '각성한 강화병',
        tc: '覺醒的強化兵',
      },
      fieldNotes: 43,
      shortLabel: {
        en: 'Supersoldier',
        de: 'Magitek-Soldat',
        fr: 'Guet-apens',
        ja: '覚醒の強化兵',
        cn: '觉醒的强化兵',
        ko: '각성한 강화병',
        tc: '覺醒的強化兵',
      },
      x: 8.1,
      y: 24.0,
      fateId: 1730,
    },
    dementedmentor: {
      label: {
        en: 'Demented Mentor',
        de: 'Rettende Hiebe',
        fr: 'Magie couleur sang',
        ja: '師弟の戦い',
        cn: '师徒之战',
        ko: '사제의 싸움',
        tc: '師徒之戰',
      },
      fieldNotes: 36,
      shortLabel: {
        en: 'Demented',
        de: 'Rettende Hiebe',
        fr: 'Magie',
        ja: '師弟の戦い',
        cn: '师徒之战',
        ko: '사제의 싸움',
        tc: '師徒之戰',
      },
      x: 7.2,
      y: 28.8,
      fateId: 1731,
    },
    severthestrings: {
      label: {
        en: 'Sever the Strings',
        de: 'Endkampf mit dem Puppenspieler',
        fr: 'Ainsi font les petites marionnettes',
        ja: '人形使いとの死闘',
        cn: '与人偶师的死斗',
        ko: '인형술사와 사투를 벌이다',
        tc: '與人偶師的死鬥',
      },
      fieldNotes: 32,
      shortLabel: {
        en: 'Sever',
        de: 'Endkampf (Puppenspieler)',
        fr: 'Marionnettes',
        ja: '人形使いとの死闘',
        cn: '与人偶师的死斗',
        ko: '인형술사와 사투',
        tc: '與人偶師的死鬥',
      },
      x: 11.6,
      y: 27.6,
      fateId: 1732,
    },
    thebeastsareback: {
      label: {
        en: 'The Beasts are Back',
        de: 'Die Allergrößte gibt nicht auf',
        fr: 'Des bêtes en pagagaille',
        ja: '折れない我執',
        cn: '不屈不挠的我见我执',
        ko: '꺾이지 않는 아집',
        tc: '不屈不撓的我見我執',
      },
      isCEPrecursor: true,
      shortLabel: {
        en: 'Beasts',
        de: 'Allergrößte gibt nicht auf',
        fr: 'Pagagaille',
        ja: '折れない我執',
        cn: '不屈不挠的我见我执',
        ko: '꺾이지 않는 아집',
        tc: '不屈不撓的我見我執',
      },
      x: 25.4,
      y: 14.3,
      fateId: 1733,
    },
    stillonlycountsasone: {
      label: {
        en: 'Still Only Counts as One',
        de: 'Die Schillernde und ihr Schoßhund',
        fr: 'Clarricie, sans défense ou presque',
        ja: '華麗なるお披露目会',
        cn: '华丽的展示会',
        ko: '화려한 첫선',
        tc: '華麗的展示會',
      },
      shortLabel: {
        en: 'Still',
        de: 'Schillernde ',
        fr: 'Sans défense',
        ja: '華麗なるお披露目会',
        cn: '华丽的展示会',
        ko: '화려한 첫선',
        tc: '華麗的展示會',
      },
      x: 14.5,
      y: 10.4,
      fateId: 1734,
    },
    seeqandyouwillfind: {
      label: {
        en: 'Seeq and You Will Find',
        de: 'Die Farbe des Blutes',
        fr: 'Non, c\'est non !',
        ja: '豚面との再会',
        cn: '与兽性兽心的再会',
        ko: '시크족과 재회하다',
        tc: '與獸性獸心的再會',
      },
      fieldNotes: 41,
      shortLabel: {
        en: 'Seeq',
        de: 'Farbe des Blutes',
        fr: 'Non !',
        ja: '豚面との再会',
        cn: '与兽性兽心的再会',
        ko: '시크족과 재회',
        tc: '與獸性獸心的再會',
      },
      x: 20.3,
      y: 16.5,
      fateId: 1735,
    },
    meanspirited: {
      label: {
        en: 'Mean-spirited',
        de: 'Haltet den Onmyoji!',
        fr: 'Le trésor du clan Urabe',
        ja: '歳殺の大捕物',
        cn: '岁煞大逮捕剧',
        ko: '세살신 체포',
        tc: '歲煞大逮捕劇',
      },
      fieldNotes: 39,
      shortLabel: {
        en: 'Mean',
        de: 'Onmyoji!',
        fr: 'Trésor',
        ja: '歳殺の大捕物',
        cn: '岁煞大逮捕剧',
        ko: '세살신 체포',
        tc: '歲煞大逮捕劇',
      },
      x: 25.4,
      y: 14.3,
      fateId: 1736,
    },
    arelicunleashed: {
      label: {
        en: 'A Relic Unleashed',
        de: 'Dunkelfürst Famfrit',
        fr: 'Sans issue',
        ja: '聖石片の脅威',
        cn: '圣石碎片的威胁',
        ko: '성석 조각의 위협',
        tc: '聖石碎片的威脅',
      },
      fieldNotes: 32,
      shortLabel: {
        en: 'Relic',
        de: 'Famfrit',
        fr: 'Sans issue',
        ja: '聖石片の脅威',
        cn: '圣石碎片的威胁',
        ko: '성석 조각',
        tc: '聖石碎片的威脅',
      },
      x: 25.4,
      y: 14.3,
      fateId: 1737,
    },
    whenmagesrage: {
      label: {
        en: 'When Mages Rage',
        de: 'Was du heute kannst besorgen',
        fr: 'Des cailloux, des cailloux, des cailloux !',
        ja: '術士大隊の反撃',
        cn: '术师大队的反击',
        ko: '술사대대의 반격',
        tc: '術師大隊的反擊',
      },
      shortLabel: {
        en: 'Mages',
        de: 'Was du heute kannst besorgen',
        fr: 'Cailloux',
        ja: '術士大隊の反撃',
        cn: '术师大队的反击',
        ko: '술사대대의 반격',
        tc: '術師大隊的反擊',
      },
      x: 20.3,
      y: 16.5,
      fateId: 1738,
    },
    hypertunedhavoc: {
      label: {
        en: 'Hypertuned Havoc',
        de: 'Eine goldene Gelegenheit',
        fr: 'Une opportunité en or',
        ja: '黄金の強化兵',
        cn: '黄金强化兵',
        ko: '황금색 강화병',
        tc: '黃金強化兵',
      },
      isCEPrecursor: true,
      fieldNotes: 43,
      shortLabel: {
        en: 'Hyper',
        de: 'Goldene Gelegenheit',
        fr: 'Opportunité',
        ja: '黄金の強化兵',
        cn: '黄金强化兵',
        ko: '황금색 강화병',
        tc: '黃金強化兵',
      },
      x: 16.6,
      y: 16.8,
      fateId: 1739,
    },
    attackofthesupersoldiers: {
      label: {
        en: 'Attack of the Supersoldiers',
        de: 'Verstärkung für die Mech-Einheit',
        fr: 'Il est plus d\'un',
        ja: '強化兵部隊の強襲',
        cn: '强化兵部队的强袭',
        ko: '강화병 부대의 강습',
        tc: '強化兵部隊的強襲',
      },
      isCEPrecursor: true,
      fieldNotes: 35,
      shortLabel: {
        en: 'Supersoldiers',
        de: 'Verstärkung .. Mech-Einheit',
        fr: 'Plus d\'un',
        ja: '強化兵部隊の強襲',
        cn: '强化兵部队的强袭',
        ko: '강화병 부대',
        tc: '強化兵部隊的強襲',
      },
      x: 16.6,
      y: 16.8,
      fateId: 1740,
    },
    thestudentbecalmsthemaster: {
      label: {
        en: 'The Student Becalms the Master',
        de: 'Rettende Hiebe Teil 2',
        fr: 'L\'élève dépasse le maître',
        ja: '師弟の絆',
        cn: '师徒之情',
        ko: '사제의 연',
        tc: '師徒之情',
      },
      fieldNotes: 36,
      shortLabel: {
        en: 'Student',
        de: 'Rettende Hiebe 2',
        fr: 'Élève',
        ja: '師弟の絆',
        cn: '师徒之情',
        ko: '사제의 연',
        tc: '師徒之情',
      },
      x: 14.5,
      y: 10.4,
      fateId: 1741,
    },
    attackofthemachines: {
      label: {
        en: 'Attack of the Machines',
        de: 'Magitek-Maschinen en masse',
        fr: 'Fabrication en série',
        ja: 'シシニアスの量産計画',
        cn: '西西尼乌斯的量产计划',
        ko: '시시니우스의 양산 계획',
        tc: '西西尼烏斯的量產計劃',
      },
      shortLabel: {
        en: 'Machines',
        de: 'Magitek-Maschinen en masse',
        fr: 'En série',
        ja: 'シシニアスの量産計画',
        cn: '西西尼乌斯的量产计划',
        ko: '양산 계획',
        tc: '西西尼烏斯的量產計劃',
      },
      x: 12.1,
      y: 13.6,
      fateId: 1742,
    },
    dalriada: {
      label: {
        en: 'The Dalriada',
        de: 'Sturm auf die Dalriada',
        fr: 'Le Dal\'riada',
        ja: '旗艦ダル・リアータ攻略戦',
        cn: '旗舰达尔里阿达号攻略战',
        ko: '기함 달리아다 공략전',
        tc: '旗艦達爾里阿達號攻略戰',
      },
      shortLabel: {
        en: 'Dalriada',
        de: 'Dalriada',
        fr: 'Dal\'riada',
        ja: '旗艦ダル・リアータ攻略戦',
        cn: '旗舰战',
        ko: '달리아다',
        tc: '旗艦戰',
      },
      x: 25.9,
      y: 8.2,
      isCritical: true,
      ceKey: 0,
      // TODO: this needs a 60 minute respawn *after* it finishes.
      // respawnMinutes: 60,
    },
    onserpentswings: {
      label: {
        en: 'On Serpents\' Wings',
        de: 'Der Geistertrupp',
        fr: 'Zirnitrop',
        ja: '妖霊使い「妖戦百人隊」',
        cn: '群蛇狂舞——妖战百人队',
        ko: '요귀술사 \'요전백인대\'',
        tc: '群蛇狂舞——妖戰百人隊',
      },
      shortLabel: {
        en: 'Serpents',
        de: 'Geistertrupp',
        fr: 'Zirnitrop',
        ja: '妖霊使い「妖戦百人隊」',
        cn: '妖战百人队',
        ko: '요전백인대',
        tc: '妖戰百人隊',
      },
      x: 31.4,
      y: 37.4,
      isCritical: true,
      ceKey: 1,
    },
    feelingtheburn: {
      label: {
        en: 'Feeling the Burn',
        de: 'Schwarzbrands Testflug',
        fr: 'On arrête le progrès',
        ja: '試作飛行型魔導アーマー「ブラックバーン」',
        cn: '试制性飞行魔导装甲——黑色燃焰',
        ko: '시험작 비행형 마도 아머 \'블랙번\'',
        tc: '試製性飛行魔導裝甲——黑色燃焰',
      },
      fieldNotes: 35,
      shortLabel: {
        en: 'Burn',
        de: 'Schwarzbrands',
        fr: 'Progrès',
        ja: '試作飛行型魔導アーマー「ブラックバーン」',
        cn: '黑色燃焰',
        ko: '블랙번',
        tc: '黑色燃焰',
      },
      x: 16.6,
      y: 16.8,
      isCritical: true,
      isDuelPrecursor: true,
      ceKey: 2,
    },
    thebrokenblade: {
      label: {
        en: 'The Broken Blade',
        de: 'Hyper-Dabog, Stärkster unter Stärksten',
        fr: 'Dabog, l\'hyper-renforcé',
        ja: '悲業の強化兵「ハイパーチューンド・ダボグ」',
        cn: '惨无人道的强化兵——超级调整兵达波格',
        ko: '비운의 강화병 \'특수강화병 다보그\'',
        tc: '慘無人道的強化兵——超級調整兵達波格',
      },
      fieldNotes: 43,
      shortLabel: {
        en: 'Blade',
        de: 'Hyper-Dabog',
        fr: 'Dabog',
        ja: '悲業の強化兵「ハイパーチューンド・ダボグ」',
        cn: '惨无人道的强化兵',
        ko: '다보그',
        tc: '慘無人道的強化兵',
      },
      x: 26.5,
      y: 35.6,
      isCritical: true,
      isDuel: true,
      respawnMinutes: 60,
      ceKey: 3,
    },
    frombeyondthegrave: {
      label: {
        en: 'From Beyond the Grave',
        de: 'Shemhazai der Verräter',
        fr: 'Le Sycophante',
        ja: '模造密告者「IVレギオン・シュミハザ」',
        cn: '复制告密者——第四军团谢米哈扎',
        ko: '모조 밀고자 \'IV군단 셰미하자\'',
        tc: '複製告密者——第四軍團謝米哈扎',
      },
      fieldNotes: 37,
      shortLabel: {
        en: 'Grave',
        de: 'Shemhazai',
        fr: 'Sycophante',
        ja: '模造密告者「IVレギオン・シュミハザ」',
        cn: '复制告密者',
        ko: '셰미하자',
        tc: '複製告密者',
      },
      x: 20.2,
      y: 37.4,
      isCritical: true,
      ceKey: 4,
    },
    withdiremiteandmain: {
      label: {
        en: 'With Diremite and Main',
        de: 'Hedetet, Stachel des Karglands',
        fr: 'C\'est dans ma nature',
        ja: '焦土の魔蠍「ヘデテト」',
        cn: '焦土魔蝎——赫德提特',
        ko: '초토의 마수 전갈 \'헤데테트\'',
        tc: '焦土魔蠍——赫德提特',
      },
      shortLabel: {
        en: 'Diremite',
        de: 'Hedetet',
        fr: 'Ma nature',
        ja: '焦土の魔蠍「ヘデテト」',
        cn: '焦土魔蝎',
        ko: '헤데테트',
        tc: '焦土魔蠍',
      },
      x: 17.0,
      y: 32.1,
      isCritical: true,
      ceKey: 5,
    },
    herecomesthecavalry: {
      label: {
        en: 'Here Comes the Cavalry',
        de: 'Halb Pferd, halb Garlear',
        fr: 'Un cavalier qui surgit hors de la nuit',
        ja: '鋼鉄の人馬「魔導騎兵大隊」',
        cn: '钢铁人马——魔导骑兵大队',
        ko: '강철의 인마 \'마도기병대대\'',
        tc: '鋼鐵人馬——魔導騎兵大隊',
      },
      shortLabel: {
        en: 'Cavalry',
        de: 'Halb Pferd',
        fr: 'Cavalier',
        ja: '鋼鉄の人馬「魔導騎兵大隊」',
        cn: '钢铁人马',
        ko: '마도기병대대',
        tc: '鋼鐵人馬',
      },
      x: 6.4,
      y: 37.2,
      isCritical: true,
      ceKey: 6,
    },
    headofthesnake: {
      label: {
        en: 'Head of the Snake',
        de: 'Menenius, Tribunus der IV. Legion',
        fr: 'Mener par l\'exemple',
        ja: '第IV軍団分遣隊長「メネニウス」',
        cn: '第四军团军政官——梅内纽斯',
        ko: '제IV군단 분견대장 \'메네니우스\'',
        tc: '第四軍團軍政官——梅內紐斯',
      },
      fieldNotes: 45,
      shortLabel: {
        en: 'Snake',
        de: 'Menenius',
        fr: 'Par l\'exemple',
        ja: '第IV軍団分遣隊長「メネニウス」',
        cn: '第四军团军政官',
        ko: '메네니우스',
        tc: '第四軍團軍政官',
      },
      x: 5.3,
      y: 31.9,
      isCritical: true,
      isDuel: true,
      respawnMinutes: 60,
      ceKey: 7,
    },
    therewouldbeblood: {
      label: {
        en: 'There Would Be Blood',
        de: 'Hanbi, König im Exil',
        fr: 'Le Roi des Cendres',
        ja: '異界の魔王「ハンビ」',
        cn: '异界魔王——汉比',
        ko: '이계의 폐왕 \'한비\'',
        tc: '異界魔王——漢比',
      },
      shortLabel: {
        en: 'Blood',
        de: 'Hanbi',
        fr: 'Cendres',
        ja: '異界の魔王「ハンビ」',
        cn: '异界魔王',
        ko: '한비',
        tc: '異界魔王',
      },
      x: 13.7,
      y: 26.0,
      isCritical: true,
      ceKey: 8,
    },
    nevercrywolf: {
      label: {
        en: 'Never Cry Wolf',
        de: 'Eiswolf Hrodvitnir',
        fr: 'Et n\'y Hród\'viens plus !',
        ja: '邪悪なる氷狼「フローズヴィトニル」',
        cn: '邪恶冰狼——恶名苍狼',
        ko: '사악한 얼음늑대 \'흐로드비트니르\'',
        tc: '邪惡冰狼——惡名蒼狼',
      },
      shortLabel: {
        en: 'Wolf',
        de: 'Hrodvitnir',
        fr: 'Hród\'vnir',
        ja: '邪悪なる氷狼「フローズヴィトニル」',
        cn: '邪恶冰狼',
        ko: '흐로드비트니르',
        tc: '邪惡冰狼',
      },
      x: 4.9,
      y: 25.3,
      isCritical: true,
      isDuelPrecursor: true,
      ceKey: 9,
    },
    timetoburn: {
      label: {
        en: 'Time to Burn',
        de: 'Dämonid Belias',
        fr: 'Le Titan',
        ja: '模造魔人「IVレギオン・ベリアス」',
        cn: '复制魔人——第四军团贝利亚斯',
        ko: '모조 마인 \'IV군단 벨리아스\'',
        tc: '複製魔人——第四軍團貝利亞斯',
      },
      shortLabel: {
        en: 'Time',
        de: 'Belias',
        fr: 'Titan',
        ja: '模造魔人「IVレギオン・ベリアス」',
        cn: '复制魔人',
        ko: '벨리아스',
        tc: '複製魔人',
      },
      x: 10.5,
      y: 21.5,
      isCritical: true,
      ceKey: 10,
    },
    leanmeanmagitekmachines: {
      label: {
        en: 'Lean, Mean, Magitek Machines',
        de: 'Die Gepanzerte Zenturie',
        fr: 'Réusinage de code',
        ja: '新兵器投入「機甲百人隊」',
        cn: '新兵器投入——机甲百人队',
        ko: '신병기 투입 \'기갑백인대\'',
        tc: '新兵器投入——機甲百人隊',
      },
      shortLabel: {
        en: 'Lean, Mean',
        de: 'Gepanzerte Zenturie',
        fr: 'Réusinage',
        ja: '新兵器投入「機甲百人隊」',
        cn: '机甲百人队',
        ko: '기갑백인대',
        tc: '機甲百人隊',
      },
      x: 15.2,
      y: 13.0,
      isCritical: true,
      ceKey: 11,
    },
    worntoashadow: {
      label: {
        en: 'Worn to a Shadow',
        de: 'Alkonost, schrecklich und gefiedert',
        fr: 'Oiseau d\'enfer',
        ja: '有角の凶鳥「アルコノスト」',
        cn: '有角凶鸟——阿尔科诺斯特',
        ko: '뿔 달린 흉조 \'알코노스트\'',
        tc: '有角兇鳥——阿爾科諾斯特',
      },
      shortLabel: {
        en: 'Shadow',
        de: 'Alkonost',
        fr: 'Oiseau',
        ja: '有角の凶鳥「アルコノスト」',
        cn: '有角凶鸟',
        ko: '알코노스트',
        tc: '有角兇鳥',
      },
      x: 11.8,
      y: 7.6,
      isCritical: true,
      ceKey: 12,
    },
    afamiliarface: {
      label: {
        en: 'A Familiar Face',
        de: 'Hashmallim der Einiger',
        fr: 'Le Grand Ordonnateur',
        ja: '模造統制者「IVレギオン・ハシュマリム」',
        cn: '复制统治者——第四军团哈修马利姆',
        ko: '모조 통제자 \'IV군단 하쉬말림\'',
        tc: '複製統治者——第四軍團哈修馬利姆',
      },
      shortLabel: {
        en: 'Familiar',
        de: 'Hashmallim',
        fr: 'Ordonnateur',
        ja: '模造統制者「IVレギオン・ハシュマリム」',
        cn: '复制统治者',
        ko: '하쉬말림',
        tc: '複製統治者',
      },
      x: 28.0,
      y: 29.2,
      isCritical: true,
      isDuelPrecursor: true,
      ceKey: 13,
    },
    lookstodiefor: {
      label: {
        en: 'Looks to Die For',
        de: 'Regenbogenschlange Ayda',
        fr: 'Écaillage en règle',
        ja: '輝ける虹蛇「アイダ」',
        cn: '光辉虹蛇——阿依达',
        ko: '빛나는 무지개뱀 \'아이다\'',
        tc: '光輝虹蛇——阿依達',
      },
      shortLabel: {
        en: 'Looks',
        de: 'Ayda',
        fr: 'Écaillage',
        ja: '輝ける虹蛇「アイダ」',
        cn: '光辉虹蛇',
        ko: '아이다',
        tc: '光輝虹蛇',
      },
      x: 17.4,
      y: 9.8,
      isCritical: true,
      ceKey: 14,
    },
    takingthelyonsshare: {
      label: {
        en: 'Taking the Lyon\'s Share',
        de: 'Revanche: Lyon der Bestienkönig',
        fr: 'La revanche de Lyon',
        ja: '戦慄の百獣使い「獣王ライアン」',
        cn: '战栗的百兽之王——兽王莱昂',
        ko: '전율하는 백수의 왕 \'마수왕 라이언\'',
        tc: '戰慄的百獸之王——獸王萊昂',
      },
      fieldNotes: 44,
      shortLabel: {
        en: 'Lyon\'s',
        de: 'Revanche: Lyon',
        fr: 'Lyon',
        ja: '戦慄の百獣使い「獣王ライアン」',
        cn: '兽王莱昂',
        ko: '라이언',
        tc: '獸王萊昂',
      },
      x: 22.5,
      y: 13.2,
      isCritical: true,
      isDuel: true,
      respawnMinutes: 60,
      ceKey: 15,
    },
  },
};
